export const formatSize = (
    sizeString: string
  ): { message: string; warning: boolean } => {
    if (!sizeString) {
      return { message: '-', warning: false };
    }
    const sizeInMB = Number.parseInt(sizeString) / 1024 / 1024;
    return { message: `${sizeInMB.toFixed(2)} MB`, warning: sizeInMB > 50 };
  };